<template>
  <div>
    <el-card>
      <div slot="header" class="font-bold">提现处理</div>
      <el-table :data="list" v-loading="loading" size="small">
        <el-table-column prop="bloggerName" label="博主" width="120" />
        <el-table-column prop="amount" label="金额" width="100"><template slot-scope="{row}">¥{{ row.amount }}</template></el-table-column>
        <el-table-column prop="alipayAccount" label="支付宝" width="180" />
        <el-table-column prop="realName" label="真实姓名" width="100" />
        <el-table-column prop="createdAt" label="申请时间" width="160">
          <template slot-scope="{row}">{{ formatDate(row.createdAt) }}</template>
        </el-table-column>
        <el-table-column label="操作" min-width="200">
          <template slot-scope="{row}">
            <el-button type="success" size="mini" @click="openApprove(row)">打款</el-button>
            <el-button type="danger" size="mini" @click="openReject(row)">驳回</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination style="margin-top:16px;text-align:right" background layout="total,prev,pager,next"
        :total="total" :page-size="size" :current-page.sync="page" @current-change="fetch" />
    </el-card>

    <!-- Approve dialog -->
    <el-dialog title="确认打款" :visible.sync="approveVisible" width="400px">
      <el-form label-width="80px" size="small">
        <el-form-item label="转账截图">
          <el-input v-model="approveForm.transferImage" placeholder="转账截图URL" />
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="approveForm.remark" placeholder="备注（选填）" />
        </el-form-item>
      </el-form>
      <div slot="footer"><el-button @click="approveVisible=false">取消</el-button>
        <el-button type="primary" @click="doApprove">确认打款</el-button></div>
    </el-dialog>

    <!-- Reject dialog -->
    <el-dialog title="驳回申请" :visible.sync="rejectVisible" width="400px">
      <el-form label-width="80px" size="small">
        <el-form-item label="驳回理由">
          <el-input v-model="rejectReason" type="textarea" placeholder="请输入驳回理由" />
        </el-form-item>
      </el-form>
      <div slot="footer"><el-button @click="rejectVisible=false">取消</el-button>
        <el-button type="danger" @click="doReject">确认驳回</el-button></div>
    </el-dialog>
  </div>
</template>

<script>
import { withdrawApi } from '../api';

export default {
  data() {
    return {
      list: [], page: 1, size: 10, total: 0, loading: false,
      approveVisible: false, rejectVisible: false,
      approveForm: { transferImage: '', remark: '' },
      rejectReason: '',
      currentRow: null
    };
  },
  created() { this.fetch(); },
  methods: {
    async fetch() {
      this.loading = true;
      const res = await withdrawApi.pending({ page: this.page, size: this.size });
      this.list = res.data.list;
      this.total = res.data.total;
      this.loading = false;
    },
    openApprove(row) {
      this.currentRow = row;
      this.approveForm = { transferImage: '', remark: '' };
      this.approveVisible = true;
    },
    async doApprove() {
      await withdrawApi.approve(this.currentRow.id, this.approveForm);
      this.$message.success('打款成功');
      this.approveVisible = false;
      this.fetch();
    },
    openReject(row) {
      this.currentRow = row;
      this.rejectReason = '';
      this.rejectVisible = true;
    },
    async doReject() {
      if (!this.rejectReason) { this.$message.warning('请输入驳回理由'); return; }
      await withdrawApi.reject(this.currentRow.id, { reason: this.rejectReason });
      this.$message.success('已驳回');
      this.rejectVisible = false;
      this.fetch();
    },
    formatDate(d) {
      if (!d) return '';
      return new Date(d).toLocaleString('zh-CN');
    }
  }
};
</script>
